import {
  FETCH_BV_REVIEW_REQUEST,
  FETCH_BV_REVIEW_SUCCESS,
  FETCH_BV_REVIEW_FAILURE
} from '../../actionTypes/bazaarVoiceReviewActionTypes'

const initialState = {
  data: {},
  meta: {}
}

const buildRequestState = (oldState, payload) => {
  const { partNumber } = payload
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const oldProductReviews = oldData.productReviews || {}
  const oldAllFetchedReviews = oldData.allFetchedReviews
  const oldSortOrder = oldData.sortOrder
  const oldStarFilter = oldData.starFilter
  const oldPartNumber = oldMeta.currentPartNumber
  // Used to reset the allFetchedReviews, otherwise an error could result in duplicate reviews in the allFetchedReviews Array
  const oldError = oldMeta[partNumber] ? oldMeta[partNumber].errorDetail : ''

  const newState = {
    ...oldState,
    data: {
      ...oldData,
      sortOrder: oldSortOrder || undefined,
      starFilter: oldStarFilter || undefined,
      allFetchedReviews: partNumber !== oldPartNumber || oldError.length > 1 ? [] : oldAllFetchedReviews || [],
      productReviews: {
        ...oldProductReviews,
        [partNumber]: oldProductReviews[partNumber] || undefined
      },
      cache: {
        ...oldData.cache
      },
      stats: oldData.stats
    },
    meta: {
      ...oldMeta,
      currentPartNumber: partNumber,
      [partNumber]: {
        ...oldMeta[partNumber],
        errorDetail: '',
        requestDone: false
      }
    }
  }
  return newState
}

const buildSuccessState = (oldState, payload) => {
  const { partNumber, newData } = payload
  const { cache, reviews, stats, allFetchedReviews, sortOrder, starFilter } = newData
  const { data: oldData = {}, meta: oldMeta = {} } = oldState

  const oldProductReviews = oldData.productReviews || {}
  const oldAllFetchedReviews = oldData.allFetchedReviews || []
  const sortOrderHasChanged = oldData.sortOrder !== sortOrder
  const starFilterHasChanged = oldData.starFilter !== starFilter

  const newState = {
    ...oldState,
    data: {
      ...oldData,
      sortOrder,
      starFilter,
      allFetchedReviews:
        sortOrderHasChanged || starFilterHasChanged
          ? [...allFetchedReviews]
          : [...oldAllFetchedReviews, ...allFetchedReviews],
      productReviews: {
        ...oldProductReviews,
        [partNumber]: [...reviews]
      },
      cache: {
        ...oldData.cache,
        ...cache
      },
      stats
    },
    meta: {
      ...oldMeta,
      currentPartNumber: partNumber,
      [partNumber]: {
        ...oldMeta[partNumber],
        errorDetail: '',
        requestDone: true
      }
    },
    reviewsSummary: newData.reviewsSummary
  }

  return newState
}

const buildFailureState = (oldState, payload) => {
  const { partNumber, errorDetail } = payload
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const oldProductReviews = oldData.productReviews || {}
  const oldSortOrder = oldData.sortOrder
  const oldStarFilter = oldData.starFilter

  const newState = {
    ...oldState,
    data: {
      ...oldData,
      sortOrder: oldSortOrder || undefined,
      starFilter: oldStarFilter || undefined,
      allFetchedReviews: [],
      productReviews: {
        ...oldProductReviews,
        [partNumber]: oldProductReviews[partNumber] || undefined
      },
      cache: {
        ...oldData.cache
      },
      stats: {
        attributes: {}
      }
    },
    meta: {
      ...oldMeta,
      currentPartNumber: partNumber,
      [partNumber]: {
        ...oldMeta[partNumber],
        errorDetail,
        requestDone: true
      }
    }
  }
  return newState
}

const bazaarVoiceReviewReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_BV_REVIEW_REQUEST:
      return buildRequestState(state, payload)
    case FETCH_BV_REVIEW_SUCCESS:
      return buildSuccessState(state, payload)
    case FETCH_BV_REVIEW_FAILURE:
      return buildFailureState(state, payload)
    default:
      return state
  }
}

export { initialState, bazaarVoiceReviewReducer }
